import React from 'react';
import CandidateDetails from './CandidateDetails';
import CastingReview from './CastingReview';
import ReviewLogsTable from './ReviewLogsTable';
import { 
    VideoQualityCard, 
    AiPerformanceCard, 
    CastingMatchBreakdownCard, 
    AiExplainabilityCard, 
    CastingMatchScoreCard 
} from './AiAnalysisSection';

const VideoAuditionSection = ({
    selectedApp,
    talentAge,
    tp,
    handleViewCandidateProfile,
    ai,
    hasPermission,
    isReviewSubmitted,
    hoverRating,
    setHoverRating,
    ratingStar,
    setRatingStar,
    reviewText,
    setReviewText,
    decision,
    setDecision,
    handleSaveReview,
    saveReviewLoading,
    fieldErrors,
    setFieldErrors
}) => {
    return (
        <div className="row g-4">
            {/* COLUMN 1: Video, Script & Candidate Details */}
            <div className="col-12 col-lg-4 d-flex flex-column gap-4">
                <div className="card-dark p-3 rounded" style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                    <div className="fw-bold mb-3">Audition Video</div>
                    <div className="position-relative mb-0 bg-black rounded overflow-hidden" style={{ aspectRatio: '16/9' }}>
                        {selectedApp.c_videoUrl || selectedApp.videoUrl ? (
                            <video controls width="100%" height="100%" src={selectedApp.c_videoUrl || selectedApp.videoUrl} style={{ objectFit: 'contain', backgroundColor: '#000' }} />
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100 text-muted small">No Video Uploaded</div>
                        )}
                    </div>
                </div>

                <CandidateDetails 
                    selectedApp={selectedApp} 
                    talentAge={talentAge} 
                    tp={tp} 
                    handleViewCandidateProfile={handleViewCandidateProfile} 
                />

                <VideoQualityCard ai={ai} />
            </div>

            {/* COLUMN 2: AI Performance & Match Breakdown & AI Explainability */}
            <div className="col-12 col-lg-4 d-flex flex-column gap-4">
                <AiPerformanceCard ai={ai} />
                <CastingMatchBreakdownCard ai={ai} />
                <AiExplainabilityCard ai={ai} />
            </div>

            {/* COLUMN 3: Score, Review & Logs */}
            <div className="col-12 col-lg-4 d-flex flex-column gap-4">
                <CastingMatchScoreCard ai={ai} />

                {hasPermission('Auditions', 'Action') && (
                    <div 
                        className="review-card-wrapper" 
                        style={{ 
                            pointerEvents: isReviewSubmitted() ? 'none' : 'auto',
                            opacity: isReviewSubmitted() ? 0.65 : 1
                        }}
                    >
                        <CastingReview 
                            bookingType={selectedApp?.bookingType}
                            hoverRating={hoverRating} 
                            setHoverRating={setHoverRating}
                            ratingStar={ratingStar} 
                            setRatingStar={setRatingStar}
                            reviewText={reviewText} 
                            setReviewText={setReviewText}
                            decision={decision} 
                            setDecision={setDecision}
                            handleSaveReview={handleSaveReview} 
                            saveReviewLoading={saveReviewLoading}
                            fieldErrors={fieldErrors} 
                            setFieldErrors={setFieldErrors}
                            disabled={isReviewSubmitted()} 
                        />
                    </div>
                )}

                <ReviewLogsTable selectedApp={selectedApp} />
            </div>
        </div>
    );
};

export default VideoAuditionSection;
